import { render, staticRenderFns } from "./SafeDoubleBtnDialog.vue?vue&type=template&id=6a265a1e&scoped=true"
import script from "./SafeDoubleBtnDialog.vue?vue&type=script&lang=js"
export * from "./SafeDoubleBtnDialog.vue?vue&type=script&lang=js"
import style0 from "./SafeDoubleBtnDialog.vue?vue&type=style&index=0&id=6a265a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a265a1e",
  null
  
)

export default component.exports